import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { LogElement } from '@models/order';
import { FormatData } from '@classes/format-data';

@Component({
  selector: 'app-last-editor-field',
  templateUrl: './last-editor-field.component.html',
  styleUrls: ['./last-editor-field.component.css'],
  providers: [DatePipe],
})
export class LastEditorFieldComponent {
  @Input() orderForm: FormGroup;

  constructor(private datePipe: DatePipe) {}

  get sortedLogs(): LogElement[] {
    const logs = this.orderForm?.value?.log;
    if (!logs?.length) {
      return [];
    }
    return logs
      .slice()
      .sort(
        (a, b) =>
          new Date(b.date ?? 0).getTime() - new Date(a.date ?? 0).getTime()
      );
  }

  get latestLog(): LogElement | null {
    return this.sortedLogs[0] ?? null;
  }

  get displayInitials(): string {
    if (this.latestLog?.initials) {
      return this.latestLog.initials;
    }
    return this.sortedLogs.find((log) => log.initials)?.initials ?? '';
  }

  get displayValue(): string {
    if (!this.hasLogs) {
      return '';
    }
    const date = this.datePipe.transform(
      this.latestLog?.date,
      'MM/dd/yyyy',
      'PST'
    );
    return date ? `${this.displayInitials} – ${date}` : this.displayInitials;
  }

  get hasLogs(): boolean {
    return this.sortedLogs.length > 0;
  }

  formatLogItem(item?: string): string {
    return FormatData.formatLogItem(item);
  }
}
